import React from "react";
import { Link } from "react-router-dom";
import useFormValidationResetPassword from "../../Hooks/ResetpasswordHook"
import { PiEyeSlashThin } from "react-icons/pi";
import { PiEyeThin } from "react-icons/pi";
import { ReactComponent as BlackVatugIcon } from "../../Asset/black.svg";
import { useNavigate } from "react-router-dom";
import "./Resetpassword.css"

const Resetpassword = () => {
  const {
    email,
    password,
    confirmPassword,
    OTP,
    error,
    successMessage,
    isLoading,
    handleInputChange,
    handleSubmit,
    handleShow,
    show,
    handleShow2,
    show2
  } = useFormValidationResetPassword();
  const navigate = useNavigate()


  return (
    <div className="reset-pass-container">
      <div className="content-card">
      <div className="wrap">
        <BlackVatugIcon onClick={() => navigate("/")}/>
        <Link to="/Login" >Back</Link>
        </div>
        <form onSubmit={handleSubmit}>
        <h3>Reset Password</h3>
        <span>An OTP has been sent to your Email address</span>
          <label>
            Email Address
            <input
              type="email"
              name="email"
              value={email}
              placeholder="Enter"
              onChange={handleInputChange}
            />
          </label>
          <label>
            New Password
            <span>
            <input
             type={show ? "text" : "password"}
              name="password"
              value={password}
              placeholder="Enter"
              onChange={handleInputChange}
              />
              {
                show ? <PiEyeSlashThin onClick={handleShow} /> : <PiEyeThin onClick={handleShow} />
              }
              </span>
          </label>
          <label>
            Confirm Password
            <span>
            <input
             type={show2 ? "text" : "password"}
              name="confirmPassword"
              value={confirmPassword}
              placeholder="Enter"
              onChange={handleInputChange}
              />
               {
                show2 ? <PiEyeSlashThin onClick={handleShow2} /> : <PiEyeThin onClick={handleShow2} />
              }
              </span>
          </label>
          <label>
            OTP
            <input
              type="text"
              name="OTP"
              value={OTP}
              placeholder="Enter"
              onChange={handleInputChange}
            />
          </label>
          {error && <p className="error">{error}</p>}
          {successMessage && <p className="success">{successMessage}</p>}
          <button type="submit" disabled={isLoading}>
            {isLoading ? "Validating..." : "Reset Password"}
          </button>
        </form>
      </div>
      <div className="img"></div>
    </div>
  );
};

export default Resetpassword;